import {permissionObj} from "../../../Helpers/permission";

export const TABS_CARD_DESIGNER = {
    TEMPLATES: {
        INDEX: 0,
        TRANS: "templates",
    },
    RESOURCES: {
        INDEX: 1,
        TRANS: "resources",
    }
}

export function TAB_PERMISSION_CARD_DESIGNER(){
    return {
        CREATE: {
            [TABS_CARD_DESIGNER.TEMPLATES.INDEX]: permissionObj?.WEB_CARD_DESIGNER_READ,
            [TABS_CARD_DESIGNER.RESOURCES.INDEX]: permissionObj?.WEB_RESOURCES_READ,
        },
        DELETE: {
            [TABS_CARD_DESIGNER.TEMPLATES.INDEX]: permissionObj?.WEB_CARD_DESIGNER_DELETE,
            [TABS_CARD_DESIGNER.RESOURCES.INDEX]: permissionObj?.WEB_RESOURCES_DELETE,
        }
    }
}
